import { TREQUEST_ATTACHMENT_APPROVAL_LIST, TRESPONSE_ATTACHMENT_APPROVAL_LIST } from '@monorepo/types';
import { ACCORDION_TABLE_MODIFIER } from '../../model/accordion-table.modifier';
import { TAccordion, TAccordionActionInfo, TAccordionTableVM } from '../../model/accordion-table.types';

const ACTION_TAKEN_BY_MAP: Record<TREQUEST_ATTACHMENT_APPROVAL_LIST['status'], string> = {
  IN_REPAIR: 'Raised By',
  REPAIR_APPROVED: 'Approved By',
  REPAIR_REJECTED: 'Rejected By',
};

export const ATTACHMENT_APPROVAL_ACCORDION_MODEL = {
  createModel(
    data: TRESPONSE_ATTACHMENT_APPROVAL_LIST['attachmentRepairDetailList'],
    bucket: TREQUEST_ATTACHMENT_APPROVAL_LIST['status'],
    hasEditAccess: boolean,
  ): TAccordionTableVM {
    return ACCORDION_TABLE_MODIFIER.createModel(
      [
        { label: 'tm_container_labels.Date&Time', colSize: 10 },
        { label: 'tm_container_labels.LocationHeader', colSize: 12 },
      ],
      data.map(
        (item): TAccordion => ({
          id: item.attachmentSerialNumber,
          isMinimized: true,
          rowItems: [
            { type: 'DATE_AND_TIME', timestamp: item.actionTakenAt },
            { type: 'TEXT', value: item.machineLocation ?? '- -' },
          ],
          moreInfo: [
            {
              items: [
                {
                  size: 12,
                  label: ACTION_TAKEN_BY_MAP[bucket],
                  values: [{ displayName: item.actionTakenBy }],
                },
                {
                  size: 12,
                  label: 'Attachment Serial Number',
                  values: [{ displayName: item.attachmentSerialNumber }],
                },
                {
                  size: 12,
                  label: 'Machine Serial Number',
                  values: [{ displayName: item.machineSerialNumber }],
                },
              ],
            },
          ],
          actions: getActions(bucket, hasEditAccess),
        }),
      ),
      { ...(bucket !== 'REPAIR_APPROVED' && hasEditAccess ? { select: { isMulti: true } } : {}) },
    );
  },
};

function getActions(
  bucket: TREQUEST_ATTACHMENT_APPROVAL_LIST['status'],
  hasEditAccess: boolean,
): TAccordionActionInfo[] {
  if (!hasEditAccess) return [];

  switch (bucket) {
    case 'IN_REPAIR':
      return [
        { actionId: 'REPAIR_APPROVED', displayName: 'Approve' },
        { actionId: 'REPAIR_REJECTED', displayName: 'Reject' },
      ];

    case 'REPAIR_REJECTED':
      return [{ actionId: 'SENT_TO_REPAIR', displayName: 'Send To Repair' }];

    case 'REPAIR_APPROVED':
      return [];
  }
}
